var $dde062d6acd4e43a$exports = {};
$dde062d6acd4e43a$exports = {
    "pending": `v teku`
};


export {$dde062d6acd4e43a$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
